import { MailingAddressSvgComponent } from "./svg/mailing-address-svg/mailing-address-svg.component";
import { MailingAddressFastSvgComponent } from "./svg/mailing-address-svg/mailing-address-fast-svg.component";
import { ErrorMessageService } from "./_services/error-message.service";
import { ValidateSvgComponent } from "./svg/validate-svg/validate-svg.component";
import { MapfreFormComponent } from "./_components/wrapper-components/mapfre-form/mapfre-form.component";
import { MapfreDropdownComponent } from "./_components/section-components/mapfre-dropdown/mapfre-dropdown.component";
import { MapfreSwitchComponent } from "./_components/individual-components/inputs/mapfre-switch/mapfre-switch.component";
import { MapfreLabelComponent } from "./_components/individual-components/inputs/mapfre-label/mapfre-label.component";
import { MapfreLinkComponent } from "./_components/individual-components/mapfre-link/mapfre-link.component";
import { MapfreInputComponent } from "./_components/individual-components/inputs/mapfre-input/mapfre-input.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Language } from "./app.language";
// import { ModalOptions } from './_models/modal-options';
import { NgModule } from "@angular/core";
import { MapfreDesignLibraryComponent } from "./mapfre-design-library.component";
import { AlertService } from "./_services/alert.service";
import { AcmicService } from "./_services/acmic.service";
// import { MapfreButtonComponent } from './individual-components/inputs/mapfre-button/mapfre-button.component';
// // import { MapfreAlertComponent } from './individual-components/mapfre-alert/mapfre-alert.component';
// import { MapfreCheckboxComponent } from './individual-components/inputs/mapfre-checkbox/mapfre-checkbox.component';
// import { MapfreIconComponent } from './individual-components/mapfre-icon/mapfre-icon.component';
// import { MapfreInputComponent } from './individual-components/inputs/mapfre-input/mapfre-input.component';
// import { MapfreLinkComponent } from './individual-components/mapfre-link/mapfre-link.component';
// import { MapfreLabelComponent } from './individual-components/inputs/mapfre-label/mapfre-label.component';
// import { MapfreSwitchComponent } from './individual-components/inputs/mapfre-switch/mapfre-switch.component';
import { MapfreLoadingComponent } from "./_components/individual-components/mapfre-loading/mapfre-loading.component";
import { MapfreLoadingLineComponent } from "./_components/individual-components/mapfre-loadingline/mapfre-loadingline.component";
import { ModuleWithProviders } from "@angular/core";
import { ModalOptionsService } from "./_services/modal-options.service";
import { FormBaseControlService } from "./_services/form-base-control.service";
import { MapfreAlertComponent } from "./_components/individual-components/mapfre-alert/mapfre-alert.component";
//////////////////////////////////////
import { CommonModule } from "@angular/common";
import { NO_ERRORS_SCHEMA } from "@angular/core";
import { RouterModule } from "@angular/router";
// import { ReactiveFormsModule }                from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MapfreButtonComponent } from "./_components/individual-components/inputs/mapfre-button/mapfre-button.component";
import { MapfreCheckboxComponent } from "./_components/individual-components/inputs/mapfre-checkbox/mapfre-checkbox.component";
import { MapfreIconComponent } from "./_components/individual-components/mapfre-icon/mapfre-icon.component";
import { MapfreIconInformationComponent } from "./_components/section-components/mapfre-icon-information/mapfre-icon-information.component";
import { MapfreInfoDivsComponent } from "./_components/section-components/mapfre-info-divs/mapfre-info-divs.component";
import { MapfreIputWithValidationComponent } from "./_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component";
import { MapfreModalComponent } from "./_components/section-components/mapfre-modal/mapfre-modal.component";
import { MapfreCardComponent } from "./_components/wrapper-components/mapfre-card/mapfre-card.component";
import { MapfreCodeComponent } from "./_components/wrapper-components/mapfre-code/mapfre-code.component";
import { MapfreTooltipComponent } from "./_components/wrapper-components/mapfre-tooltip/mapfre-tooltip.component";
import { FooterComponent } from "./_components/global-components/footer/footer.component";
import { HeaderComponent } from "./_components/global-components/header/header.component";
import { RegExHelper } from "./_helpers/regex-helper";
import { PasswordValidation } from "./_helpers/match-repeat-password";
//SVGs
import { CreateNewPasswordSvgComponent } from "./svg/create-new-password-svg/create-new-password-svg.component";
import { CreateNewPasswordExpiredSvgComponent } from "./svg/create-new-password-expired-svg/create-new-password-expired-svg.component";
import { LoginIconSvgComponent } from "./svg/login-icon-svg/login-icon-svg.component";
import { ForgotPasswordIconSvgComponent } from "./svg/forgot-password-icon-svg/forgot-password-icon-svg.component";
import { CheckEmailIconSvgComponent } from "./svg/check-email-icon-svg/check-email-icon-svg.component";
import { TooManyAttemptsSvgComponent } from "./svg/too-many-attempts-svg/too-many-attempts-svg.component";
import { CongratsSvgComponent } from "./svg/congrats-svg/congrats-svg.component";
import { CreateAccountSvgComponent } from "./svg/create-account-svg/create-account-svg.component";
import { PolicySvgComponent } from "./svg/policy-svg/policy-svg.component";
import { PolicyErrorSvgComponent } from "./svg/policy-error-svg/policy-error-svg.component";
import { EmailErrorSvgComponent } from "./svg/email-error-svg/email-error-svg.component";
import { CarIconSvgComponent } from "./svg/car-icon-svg/car-icon-svg.component";
import { HomeIconSvgComponent } from "./svg/home-icon-svg/home-icon-svg.component";
import { AlarmColorSvgComponent } from "./svg/alarm-color-svg/alarm-color-svg.component";
import { ArrorRightSvgComponent } from "./svg/arror-right-svg/arror-right-svg.component";
import { ImportantMessageSvgComponent } from "./svg/important-message-svg/important-message-svg.component";
import { InformationIconSvgComponent } from "./svg/information-icon-svg/information-icon-svg.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AlarmMonocolorSvgComponent } from "./svg/alarm-monocolor-svg/alarm-monocolor-svg.component";
import { EditIconSVGComponent } from "./svg/edit-icon-svg/edit-icon-svg.component";
import { EmailPasswordSVGComponent } from "./svg/email-password-svg/email-password-svg.component";
import { EmailValidateSVGComponent } from "./svg/email-validate-svg/email-validate-svg.component";
import { PasswordSVGComponent } from "./svg/password-svg/password-svg.component";
import { PolicyFoundSvgComponent } from "./svg/policy-found-svg/policy-found-svg.component";
import { PolicyNotFoundSvgComponent } from "./svg/policy-not-found-svg/policy-not-found-svg.component";
import { ReportClaimSvgComponent } from "./svg/report-claim-svg/report-claim-svg.component";
import { TimeExpiredSvgComponent } from "./svg/time-expired-svg/time-expired-svg.component";
import { AccountProfileSVGComponent } from "./svg/account-profile-svg/account-profile-svg.component";
import { AccountRemovedSvgComponent } from "./svg/account-removed-svg/account-removed-svg.component";
import { BankSvgComponent } from "./svg/bank-svg/bank-svg.component";
import { EmailInUseSvgComponent } from "./svg/email-in-use-svg/email-in-use-svg.component";
import { HouseMonoColorSvgComponent } from "./svg/house-mono-color-large-svg/house-mono-color-svg.component";
import { CarMonoColorSvgComponent } from "./svg/car-mono-color-large-svg/car-mono-color-svg.component";
import { HolderMonoColorSvgComponent } from "./svg/holder-mono-color-svg/holder-mono-color-svg.component";
import { CalendarMonoColorSvgComponent } from "./svg/calendar-mono-color-svg/calendar-mono-color-svg.component";
import { MoneyMonoColorSvgComponent } from "./svg/money-mono-color-svg/money-mono-color-svg.component";
import { CarMonoColorSmallSvgComponent } from "./svg/car-mono-color-small-svg/car-mono-color-small-svg.component";
import { HouseMonoColorSmallSvgComponent } from "./svg/house-mono-color-small-svg/house-mono-color-small-svg.component";
import { MyinsuranceSvgComponent } from "./svg/myinsurance-svg/myinsurance-svg.component";
import { BillingSvgComponent } from "./svg/billing-svg/billing-svg.component";
import { BillingFillingSvgComponent } from "./svg/billing-filling-svg/billing-filling-svg.component";
import { MyinsuranceFilledSvgComponent } from "./svg/myinsurance-filled-svg/myinsurance-filled-svg.component";
import { ClaimsSvgComponent } from "./svg/claims-svg/claims-svg.component";
import { ClaimsFilledSvgComponent } from "./svg/claims-filled-svg/claims-filled-svg.component";
import { InformationFilledSvgComponent } from "./svg/information-filled-svg/information-filled-svg.component";
import { InformationSvgComponent } from "./svg/information-svg/information-svg.component";
import { ContactSvgComponent } from "./svg/contact-svg/contact-svg.component";
import { ContactFilledSvgComponent } from "./svg/contact-filled-svg/contact-filled-svg.component";
import { PlusCircleSvgComponent } from "./svg/plus-circle-svg/plus-circle-svg.component";
import { AccountCircleSvgComponent } from "./svg/account-circle-svg/account-circle-svg.component";
import { LogoutSvgComponent } from "./svg/logout-svg/logout-svg.component";
import { AddIconSVGComponent } from "./svg/add-icon-svg/add-icon-svg.component";
import { PhoneSvgComponent } from "./svg/phone-svg/phone-svg.component";
import { AddressSvgComponent } from "./svg/address-svg/address-svg.component";
import { InformationColorSvgComponent } from "./svg/information-color-svg/information-color-svg.component";
import { HouseLineSvgComponent } from "./svg/house-line-svg/house-line-svg.component";
import { LifeLineSvgComponent } from "./svg/life-line-svg/life-line-svg.component";
import { TravelLineSvgComponent } from "./svg/travel-line-svg/travel-line-svg.component";
import { BizLineSvgComponent } from "./svg/biz-line-svg/biz-line-svg.component";
import { UmbrellaLineSvgComponent } from "./svg/umbrella-line-svg/umbrella-line-svg.component";
import { MotorcycleLineSvgComponent } from "./svg/motorcycle-line-svg/motorcycle-line-svg.component";
import { WatercraftLineSvgComponent } from "./svg/watercraft-line-svg/watercraft-line-svg.component";
import { RecLineSvgComponent } from "./svg/rec-line-svg/rec-line-svg.component";
import { AutoLineSvgComponent } from "./svg/auto-line-svg/auto-line-svg.component";
import { GenericInformationTemplateComponent } from "./_components/wrapper-components/generic-information-template/generic-information-template.component";
import { NumericInputDirective } from "./_helpers/_directives/numeric-input.directive";
import { CheckingAccountPipe } from "./_helpers/_pipes/checking-account.pipe";
import { FormatPhonePipe } from "./_helpers/_pipes/format-phone.pipe";
import { EmailIconSvgComponent } from "./svg/email-icon-svg/email-icon-svg.component";
import { TooltipComponent } from "./_components/section-components/tooltip/tooltip.component";
import { GetGooglePlaceService } from "./_services/get-google-place.service";
import { ValidateAddressService } from "./_services/validate-address.service";
import { CautionColorSvgComponent } from "./svg/caution-color-svg/caution-color-svg.component";
import { Error404Component } from "./_global-screens/error-pages/error-404/error-404.component";
import { Error504Component } from "./_global-screens/error-pages/error-504/error-504.component";
import { Error400Component } from "./_global-screens/error-pages/error-400/error-400.component";
import { Error401Component } from "./_global-screens/error-pages/error-401/error-401.component";
import { Error403Component } from "./_global-screens/error-pages/error-403/error-403.component";
import { Error408Component } from "./_global-screens/error-pages/error-408/error-408.component";
import { Error410Component } from "./_global-screens/error-pages/error-410/error-410.component";
import { Error502Component } from "./_global-screens/error-pages/error-502/error-502.component";
import { Error503Component } from "./_global-screens/error-pages/error-503/error-503.component";
import { Error500Component } from "./_global-screens/error-pages/error-500/error-500.component";
import { ErrorMaintenceComponent } from "./_global-screens/error-pages/error-maintence/error-maintence.component";
import { ErrorContentComponent } from "./_global-screens/error-pages/error-content/error-content.component";
import { SvgContainerComponent } from "./svg/svg-container/svg-container.component";
import { PdfDocumentSvgComponent } from "./svg/pdf-document-svg/pdf-document-svg.component";
import { WalletSvgComponent } from "./svg/wallet-svg/wallet-svg.component";
import { AutoPaySvgComponent } from "./svg/autopay-svg/autopay-svg.component";
import { CalendarSvgComponent } from "./svg/calendar-icon-svg/calendar-icon-svg.component";
import { AutoPaySvgGuestComponent } from "./svg/autopay-guest-svg/autopay-svg-guest.component";
import { PropertySvgComponent } from "./svg/property-svg/property-svg.component";
import { AutoSvgComponent } from "./svg/auto-svg/auto-svg.component";
import { UmbrellaSvgComponent } from "./svg/umbrella-svg/umbrella-svg.component";
import { LiabilitySvgComponent } from "./svg/liability-svg/liability-svg.component";
import { GarageSvgComponent } from "./svg/garage-svg/garage-svg.component";
import { DwellingFireSvgComponent } from "./svg/dwelling-fire-svg/dwelling-fire-svg.component";
import { ErrorLinkExpireComponent } from "./_global-screens/error-pages/error-link-expire/error-link-expire.component";
import { CompanyLinkIconSvgComponent } from "./svg/company-link-icon-svg/company-link-icon-svg.component";
import { CreateCompanyIconSvgComponent } from "./svg/create-company-icon-svg/create-company-icon-svg.component";
import { OdometerSvgComponent } from "./svg/odometer-svg/odometer-svg.component";
import { NumericCommaInputDirective } from "./_helpers/_directives/numeric-comma-input.directive";
import { AcmicMyinsuranceFilledSvgComponent } from "./svg/acmic-myinsurance-filled-svg/acmic-myinsurance-filled-svg.component";
import { AcmicMyinsuranceSvgComponent } from "./svg/acmic-myinsurance-svg/acmic-myinsurance-svg.component";
import { GTagService } from "./_services/g-tag.service";
import { PaymentCCDCSvgComponent } from "./svg/payment-cc-dc/payment-cc-dc.component";
import { BankAccountSvgComponent } from "./svg/bank-account-svg/bank-account-svg.component";
import { CcDcSvgComponent } from "./svg/cc-dc-svg/cc-dc-svg.component";
import { ContactPhoneSvgComponent } from "./svg/contact-phone-svg/contact-phone-svg.component";
import { MapfreCustomTooltipComponent } from "./_components/wrapper-components/custom-tooltip/mapfre-custom-tooltip.component";
import { MapfreSlideToggleComponent } from "./_components/individual-components/inputs/mapfre-slide-toggle/mapfre-slide-toggle.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    GooglePlaceModule,
    MatSlideToggleModule,
    EmailIconSvgComponent,
    ValidateSvgComponent,
    PhoneSvgComponent,
    AddIconSVGComponent,
    AccountProfileSVGComponent,
    EditIconSVGComponent,
    PdfDocumentSvgComponent,
    WalletSvgComponent,
    AutoSvgComponent,
    UmbrellaSvgComponent,
    LiabilitySvgComponent,
    GarageSvgComponent,
    DwellingFireSvgComponent,
    PropertySvgComponent,
    AutoPaySvgComponent,
    CalendarSvgComponent,
    EmailPasswordSVGComponent,
    EmailValidateSVGComponent,
    PasswordSVGComponent,
    PolicyFoundSvgComponent,
    PolicyNotFoundSvgComponent,
    ReportClaimSvgComponent,
    TimeExpiredSvgComponent,
    AccountRemovedSvgComponent,
    OdometerSvgComponent,
    BankSvgComponent,
    EmailInUseSvgComponent,
    CreateNewPasswordSvgComponent,
    CreateNewPasswordExpiredSvgComponent,
    LoginIconSvgComponent,
    ForgotPasswordIconSvgComponent,
    CheckEmailIconSvgComponent,
    TooManyAttemptsSvgComponent,
    CongratsSvgComponent,
    CreateAccountSvgComponent,
    PolicySvgComponent,
    PolicyErrorSvgComponent,
    EmailErrorSvgComponent,
    CarIconSvgComponent,
    HomeIconSvgComponent,
    MapfreDesignLibraryComponent,
    MapfreButtonComponent,
    MapfreAlertComponent,
    MapfreCheckboxComponent,
    MapfreIconComponent,
    MapfreInputComponent,
    MapfreLinkComponent,
    MapfreLabelComponent,
    MapfreSwitchComponent,
    MapfreLoadingComponent,
    MapfreLoadingLineComponent,
    MapfreDropdownComponent,
    MapfreIconInformationComponent,
    MapfreInfoDivsComponent,
    MapfreIputWithValidationComponent,
    MapfreModalComponent,
    MapfreCardComponent,
    MapfreCodeComponent,
    MapfreFormComponent,
    MapfreTooltipComponent,
    FooterComponent,
    HeaderComponent,
    AlarmColorSvgComponent,
    ArrorRightSvgComponent,
    AlarmMonocolorSvgComponent,
    HouseMonoColorSvgComponent,
    CarMonoColorSvgComponent,
    HolderMonoColorSvgComponent,
    CalendarMonoColorSvgComponent,
    MoneyMonoColorSvgComponent,
    CarMonoColorSmallSvgComponent,
    HouseMonoColorSmallSvgComponent,
    MyinsuranceSvgComponent,
    BillingSvgComponent,
    BillingFillingSvgComponent,
    MyinsuranceFilledSvgComponent,
    ClaimsSvgComponent,
    ClaimsFilledSvgComponent,
    InformationFilledSvgComponent,
    InformationSvgComponent,
    ContactSvgComponent,
    ContactFilledSvgComponent,
    PlusCircleSvgComponent,
    AccountCircleSvgComponent,
    LogoutSvgComponent,
    AddressSvgComponent,
    InformationColorSvgComponent,
    HouseLineSvgComponent,
    LifeLineSvgComponent,
    TravelLineSvgComponent,
    BizLineSvgComponent,
    UmbrellaLineSvgComponent,
    MotorcycleLineSvgComponent,
    WatercraftLineSvgComponent,
    RecLineSvgComponent,
    AutoLineSvgComponent,
    NumericInputDirective,
    NumericCommaInputDirective,
    FormatPhonePipe,
    CheckingAccountPipe,
    GenericInformationTemplateComponent,
    TooltipComponent,
    CautionColorSvgComponent,
    Error404Component,
    Error504Component,
    Error400Component,
    Error401Component,
    Error403Component,
    Error408Component,
    Error410Component,
    Error502Component,
    Error503Component,
    Error500Component,
    ErrorMaintenceComponent,
    ErrorContentComponent,
    SvgContainerComponent,
    MailingAddressFastSvgComponent,
    MailingAddressSvgComponent,
    AutoPaySvgGuestComponent,
    ErrorLinkExpireComponent,
    ImportantMessageSvgComponent,
    InformationIconSvgComponent,
    CompanyLinkIconSvgComponent,
    CreateCompanyIconSvgComponent,
    AcmicMyinsuranceFilledSvgComponent,
    AcmicMyinsuranceSvgComponent,
    PaymentCCDCSvgComponent,
    BankAccountSvgComponent,
    CcDcSvgComponent,
    ContactPhoneSvgComponent,
    MapfreCustomTooltipComponent,
    MapfreSlideToggleComponent
  ],
  exports: [
    SvgContainerComponent,
    ErrorContentComponent,
    Error404Component,
    Error504Component,
    Error400Component,
    Error401Component,
    Error403Component,
    Error408Component,
    Error410Component,
    Error502Component,
    Error503Component,
    Error500Component,
    ErrorMaintenceComponent,
    TooltipComponent,
    EmailIconSvgComponent,
    ValidateSvgComponent,
    GenericInformationTemplateComponent,
    HouseLineSvgComponent,
    LifeLineSvgComponent,
    TravelLineSvgComponent,
    BizLineSvgComponent,
    UmbrellaLineSvgComponent,
    MotorcycleLineSvgComponent,
    WatercraftLineSvgComponent,
    RecLineSvgComponent,
    AutoLineSvgComponent,
    InformationColorSvgComponent,
    PhoneSvgComponent,
    AddIconSVGComponent,
    MyinsuranceSvgComponent,
    BillingSvgComponent,
    BillingFillingSvgComponent,
    MyinsuranceFilledSvgComponent,
    ClaimsSvgComponent,
    ClaimsFilledSvgComponent,
    InformationFilledSvgComponent,
    InformationSvgComponent,
    ContactSvgComponent,
    ContactFilledSvgComponent,
    PlusCircleSvgComponent,
    AccountCircleSvgComponent,
    LogoutSvgComponent,
    HouseMonoColorSmallSvgComponent,
    CarMonoColorSmallSvgComponent,
    MoneyMonoColorSvgComponent,
    CalendarMonoColorSvgComponent,
    HolderMonoColorSvgComponent,
    CarMonoColorSvgComponent,
    AccountProfileSVGComponent,
    EditIconSVGComponent,
    PdfDocumentSvgComponent,
    WalletSvgComponent,
    AutoSvgComponent,
    UmbrellaSvgComponent,
    LiabilitySvgComponent,
    GarageSvgComponent,
    DwellingFireSvgComponent,
    PropertySvgComponent,
    AutoPaySvgComponent,
    CalendarSvgComponent,
    EmailPasswordSVGComponent,
    EmailValidateSVGComponent,
    PasswordSVGComponent,
    PolicyFoundSvgComponent,
    PolicyNotFoundSvgComponent,
    ReportClaimSvgComponent,
    TimeExpiredSvgComponent,
    AccountRemovedSvgComponent,
    BankSvgComponent,
    EmailInUseSvgComponent,
    CreateNewPasswordSvgComponent,
    CreateNewPasswordExpiredSvgComponent,
    LoginIconSvgComponent,
    ForgotPasswordIconSvgComponent,
    CheckEmailIconSvgComponent,
    TooManyAttemptsSvgComponent,
    CongratsSvgComponent,
    CreateAccountSvgComponent,
    PolicySvgComponent,
    PolicyErrorSvgComponent,
    EmailErrorSvgComponent,
    CarIconSvgComponent,
    HomeIconSvgComponent,
    MapfreDesignLibraryComponent,
    MapfreButtonComponent,
    MapfreAlertComponent,
    MapfreCheckboxComponent,
    MapfreIconComponent,
    MapfreInputComponent,
    MapfreLinkComponent,
    MapfreLabelComponent,
    MapfreSwitchComponent,
    MapfreLoadingComponent,
    MapfreLoadingLineComponent,
    MapfreDropdownComponent,
    MapfreIconInformationComponent,
    MapfreInfoDivsComponent,
    MapfreIputWithValidationComponent,
    MapfreModalComponent,
    MapfreCardComponent,
    MapfreCodeComponent,
    MapfreFormComponent,
    MapfreTooltipComponent,
    FooterComponent,
    HeaderComponent,
    AlarmColorSvgComponent,
    ArrorRightSvgComponent,
    AlarmMonocolorSvgComponent,
    HouseMonoColorSvgComponent,
    AddressSvgComponent,
    NumericInputDirective,
    NumericCommaInputDirective,
    FormatPhonePipe,
    CheckingAccountPipe,
    CautionColorSvgComponent,
    MailingAddressFastSvgComponent,
    MailingAddressSvgComponent,
    AutoPaySvgGuestComponent,
    ErrorLinkExpireComponent,
    ImportantMessageSvgComponent,
    InformationIconSvgComponent,
    CompanyLinkIconSvgComponent,
    CreateCompanyIconSvgComponent,
    OdometerSvgComponent,
    AcmicMyinsuranceFilledSvgComponent,
    AcmicMyinsuranceSvgComponent,
    PaymentCCDCSvgComponent,
    BankAccountSvgComponent,
    CcDcSvgComponent,
    ContactPhoneSvgComponent,
    MapfreCustomTooltipComponent,
    MapfreSlideToggleComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class MapfreDesignLibraryModule {
  public static forRoot(): ModuleWithProviders<NgModule> {
    return {
      ngModule: MapfreDesignLibraryModule,
      providers: [
        AlertService,
        ModalOptionsService,
        FormBaseControlService,
        Language,
        RegExHelper,
        PasswordValidation,
        GetGooglePlaceService,
        ValidateAddressService,
        ErrorMessageService,
        AcmicService,
        GTagService
      ]
    };
  }
}
